var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
var SportHeading = /** @class */ (function (_super) {
    __extends(SportHeading, _super);
    function SportHeading(props) {
        var _this = _super.call(this, props) || this;
        _this.sportHeadingClasses = "rj-sport-heading" + ((_this.props.modifiers) ? " " + _this.props.modifiers : "");
        return _this;
    }
    SportHeading.prototype.render = function () {
        return (React.createElement("h3", { className: this.sportHeadingClasses, "data-uat": this.props.dataUat || "branch-heading" },
            React.createElement("span", { className: "rj-sport-heading-sport-name" },
                this.props.children,
                this.props.sportName)));
    };
    return SportHeading;
}(React.PureComponent));
export { SportHeading };
//# sourceMappingURL=SportHeading.js.map